import { axiosInstance } from "lib/axios";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  setParentChildGroups,
  setSelectedParentChildGroupId,
} from "../context";
import { GroupService } from "../services";
import { useUserData } from "features/User";

const GROUP_TYPES = Object.freeze({
  PARENT: 0,
  CHILD: 1,
  STANDALONE: 2,
});

export const ALL_PARENT_CHILD_GROUPS = "all-groups";

export function useParentChildGroups() {
  const dispatch = useDispatch();
  const groupService = useMemo(() => new GroupService(axiosInstance), []);
  const { groupId, groupRole, groupType } = useUserData();
  const { parentChildGroups, selectedParentChildGroupId } = useSelector(
    (state) => state.group
  );
  const [loading, setLoading] = useState(false);
  const isParentGroup = groupType === GROUP_TYPES.PARENT;
  const parentChildGroupOptions = useMemo(
    () => [
      {
        organizationId: ALL_PARENT_CHILD_GROUPS,
        organizationName: "All Groups",
      },
      ...parentChildGroups,
    ],
    [parentChildGroups]
  );

  useEffect(() => {
    if (
      groupId == null ||
      groupRole !== "OrganizationAdmin" ||
      !isParentGroup
    ) {
      dispatch(setParentChildGroups([]));
      dispatch(setSelectedParentChildGroupId(null));
      return;
    }

    async function fetchParentChildGroups() {
      setLoading(true);
      try {
        const groups = await groupService.getParentChildGroups();

        dispatch(setParentChildGroups(groups));
        dispatch(setSelectedParentChildGroupId(ALL_PARENT_CHILD_GROUPS));
      } catch (error) {
        dispatch(setParentChildGroups([]));
        dispatch(setSelectedParentChildGroupId(null));
      } finally {
        setLoading(false);
      }
    }

    fetchParentChildGroups();
  }, [dispatch, groupId, groupRole, groupService, isParentGroup]);

  return {
    isParentGroup,
    loading,
    parentChildGroups,
    parentChildGroupOptions,
    selectedParentChildGroupId,
    setSelectedParentChildGroupId: (organizationId) => {
      dispatch(setSelectedParentChildGroupId(organizationId));
    },
    showParentChildGroupSelect:
      groupId != null &&
      groupRole === "OrganizationAdmin" &&
      isParentGroup,
  };
}
